import React from 'react';
import ArrowRight from 'core/assets/icons/menu/arrow_r_menu.svg';
import { AnyObject } from 'yup';

interface SettingsMenuItemProps {
  label: string;
  iconSrc?: string;
  handleClick?: (e:any) => void;
  dataItem?: AnyObject;
}

const CListItemMenu: React.FC<SettingsMenuItemProps> = ({ label, iconSrc,handleClick,dataItem }) => {
  const _handleClick = () => {
    handleClick?.(dataItem);
  }
  return (
    <div className="flex flex-col w-full h-[52px] overflow-y-hidden	" onClick={_handleClick}>
      <div className="flex gap-5 justify-between p-4 w-full bg-white">
        <div className=" text-[14px] font-medium text-[#111111] tracking-tighter">{label}</div>
        <img loading="lazy" src={iconSrc || ArrowRight} alt="" className="object-contain shrink-0 aspect-square" />
      </div>
    </div>
  );
};

export default CListItemMenu;